// Storage utility with fallbacks for mobile browsers
// Handles Safari private mode and other storage restrictions

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const setCookie = (name, value, days = 7) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
};

const storageUtils = {
  // Set item with fallback
  setItem: (key, value) => {
    try {
      // Try localStorage first
      localStorage.setItem(key, value);
      return true;
    } catch (e) {
      try {
        // Fallback to sessionStorage
        sessionStorage.setItem(key, value);
        // Also set a cookie as backup
        setCookie(key, value);
        return true;
      } catch (e2) {
        // Last resort: only cookies
        setCookie(key, value);
        return true;
      }
    }
  },

  // Get item with fallback
  getItem: (key) => {
    try {
      // Try localStorage first
      const value = localStorage.getItem(key);
      if (value !== null) return value;
    } catch (e) {
      // Continue to fallbacks
    }

    try {
      // Try sessionStorage
      const value = sessionStorage.getItem(key);
      if (value !== null) return value;
    } catch (e) {
      // Continue to fallbacks
    }

    // Try cookies
    return getCookie(key);
  },

  // Remove item from all storages
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      // Continue
    }

    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      // Continue
    }

    deleteCookie(key);
  },

  // Check if storage is available
  isStorageAvailable: () => {
    try {
      const test = '__storage_test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return 'localStorage';
    } catch (e) {
      try {
        const test = '__storage_test__';
        sessionStorage.setItem(test, test);
        sessionStorage.removeItem(test);
        return 'sessionStorage';
      } catch (e2) {
        return 'cookies';
      }
    }
  },

  // Store auth tokens with mobile compatibility
  setAuthTokens: (token, user) => {
    storageUtils.setItem('token', token);
    storageUtils.setItem('userToken', token);
    if (user) {
      storageUtils.setItem('user', JSON.stringify(user));
      if (user._id) {
        storageUtils.setItem('userId', user._id);
      }
    }
  },

  // Get auth tokens
  getAuthTokens: () => {
    const token = storageUtils.getItem('token') || storageUtils.getItem('userToken');
    const userStr = storageUtils.getItem('user');
    let user = null;
    
    try {
      if (userStr) {
        user = JSON.parse(userStr);
      }
    } catch (e) {
      console.error('Failed to parse user data:', e);
    }

    return { token, user };
  },

  // Clear auth tokens
  clearAuthTokens: () => {
    storageUtils.removeItem('token');
    storageUtils.removeItem('userToken');
    storageUtils.removeItem('user');
    storageUtils.removeItem('userId');
  }
};

export default storageUtils;